import React from 'react'

import './spinner.scss'

const Spinner = props => (
  <div className={`spinner ${props.className}`}></div>
)
export default Spinner
